import Vue from 'vue'

export default Vue.extend({
  template: `
  <b-btn variant="outline-primary" class="float-right" @click="onReleaseClicked">{{ text }}</b-btn>
  `,
  data() {
    return {
    }
  },
  computed: {
    isActive() {
      return this.params.node.data.active
    },
    text() {
      if (this.isActive) {
        return 'Выпустить'
      }
      return 'Повторное приглашение'
    }
  },
  methods: {
    onReleaseClicked() {
      if (this.isActive) {
        this.params.context.componentParent.onParentReleaseClicked(this.params.node.data)
      } else {
        this.params.context.componentParent.onParentReinviteClicked(this.params.node.data)
      }
    }
  }
})
